import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { AddCommentRequest } from '@/api/generated/HCA'
import { ComponentType } from '@/configuration/component/component-types'

export const useCommentsAddMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: {commentData: AddCommentRequest }) =>
            hcaClientFactory.commentsApi.addComment(payload.commentData),
        onSuccess: async (response, payload) => {
            if (payload.commentData.componentType === ComponentType.Transformer) {
                await queryClient.invalidateQueries({ queryKey: ['transformers', payload.commentData.componentSid, 'reports', payload.commentData.data?.analysisType] })
            } else if (payload.commentData.componentType === ComponentType.Generator) {
                await queryClient.invalidateQueries({ queryKey: ['generators', payload.commentData.componentSid, 'measurements', payload.commentData.data?.analysisType] })
            }
            await queryClient.invalidateQueries({ queryKey: ['comments', payload.commentData.componentSid] })
        },
    })
}
